import { createFileRoute, Link } from "@tanstack/react-router"
import { ClipboardList } from "lucide-react"
import { useTranslation } from "react-i18next"
import { GoalsChecklist } from "@/components/forms/goals-checklist"
import { ValuesReflectionForm } from "@/components/forms/values-reflection-form"
import { Owners } from "@/components/owners"
import { Page } from "@/components/page"
import { Button } from "@/components/ui/button"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Typography } from "@/components/ui/typography"
import { trpc } from "@/lib/trpc"

export const Route = createFileRoute("/_authed/_professional/professional/goals/$estateId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { estateId } = Route.useParams()
  const { data: owners = [] } = trpc.estates.getEstateOwners.useQuery({ estateId })

  return (
    <Page
      headerSlot={
        <Typography as="h1" size="2xl">
          {t("pages.goals.title")}
        </Typography>
      }
    >
      <div className="mb-6">
        <Owners owners={owners} estateId={estateId} align="left">
          <Button variant="link" asChild className="px-0">
            <Link
              to="/professional/guided-forms/$estateId"
              params={{ estateId }}
              search={{ currentStep: "intro" }}
            >
              <ClipboardList className="size-4 mr-2" />
              Go to Guided Form
            </Link>
          </Button>
        </Owners>
      </div>
      <Tabs defaultValue="goals" className="w-full">
        <TabsList>
          <TabsTrigger value="goals">{t("pages.goals.tabs.estatePlanning")}</TabsTrigger>
          <TabsTrigger value="values">{t("pages.goals.tabs.valuesLegacy")}</TabsTrigger>
        </TabsList>

        <TabsContent value="goals" className="space-y-6">
          <GoalsChecklist estateId={estateId} />
        </TabsContent>

        <TabsContent value="values" className="space-y-6">
          <ValuesReflectionForm estateId={estateId} />
        </TabsContent>
      </Tabs>
    </Page>
  )
}
